import React from 'react';
import NumberFormat from 'react-number-format';
import MessageDefinitions from "../../i18n/MessageDefinitions";
import {FormattedMessage} from 'react-intl';

const SpinnerQuestion = ({questionKey, answers = [], valueChanged, attributes, answer}) => {

  const validateThenUpdate = (e, {floatValue}) => {
    const min = attributes.min ? attributes.min : 0;
    const max = attributes.max || Number.MAX_SAFE_INTEGER;
    const valueInBetween = !isNaN(floatValue) && floatValue >= min && floatValue <= max;
    valueChanged(questionKey, floatValue, valueInBetween);
  };

  const displayError = value => {
    const min = attributes.min ? attributes.min : 0;
    let message = false;

    if(!value && value !==0){
      message = <FormattedMessage {...MessageDefinitions.validationRequired} />;
    }else if(attributes.max && (value < min || value > attributes.max)){
      message = <FormattedMessage {...MessageDefinitions.validationBetween} values={{min, max: attributes.max}} />;
    }else if(value < min){
      message = <FormattedMessage {...MessageDefinitions.validationMinimum} values={{min}} />;
    }
    return  message ? <div className="invalid-feedback">{message}</div> : null;
  };

  return <div className="builderOption-answer spinner-section">
    <NumberFormat
      id={questionKey}
      className="answer form-control"
      value={answer}
      thousandSeparator
      prefix={ attributes.type === 'currency' ? '$' : ''}
      decimalPrecision={0}
      onChange={validateThenUpdate}
    />
    {displayError(answer)}
  </div>;
};

SpinnerQuestion.propTypes = {
  questionKey: React.PropTypes.string.isRequired,
  answers: React.PropTypes.array,
  valueChanged: React.PropTypes.func,
  label: React.PropTypes.string,
  answer: React.PropTypes.number
};

export default SpinnerQuestion;



/** WEBPACK FOOTER **
 ** ./src/main/js/questionGroupBuilder/components/questionTypes/SpinnerQuestion.js
 **/